import {
  Box,
  Button,
  Flex,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Text,
} from '@chakra-ui/react';
import { Table } from '@tanstack/react-table';
import _ from 'lodash';
import React, { useCallback } from 'react';
import { CSVLink } from 'react-csv';
import { utils, writeFile } from 'xlsx';

import {
  date as commonDate,
  utils as commonUtils,
} from '@finley-technologies/common';

import { colors } from 'packages/common-frontend/colors';
import { Icon } from 'packages/common-frontend/components/icons';

export const getTanstackVisibleDataForDownload = ({
  tableInstance,
}: {
  tableInstance: Table<any>;
}) => {
  const dataRows = _.map(tableInstance.getFilteredRowModel().rows, (row) => {
    const dataRow: { [key: string]: any } = {};

    _.forEach(row.getVisibleCells(), (cell) => {
      dataRow[
        cell.column.columnDef.header?.toString() ?? cell.column.id
      ] = cell.getValue();
    });
    return dataRow;
  });

  const headers = _.map(_.keys(dataRows[0]), (headerKey) => {
    return {
      label: commonUtils.toTitleCase(headerKey),
      key: headerKey,
    };
  });

  return { dataRows, headers };
};

export interface CsvDownloadLinkProps {
  dataRows: { [key: string]: any }[];
  headers: { label: string; key: any }[];
  filenamePrefix: string;
}
export const CsvXlsxDownloadSelect = ({
  dataRows,
  headers,
  filenamePrefix,
}: CsvDownloadLinkProps) => {
  const todayFullDateStr = commonDate.currentDateStr();
  const filename = `${_.snakeCase(filenamePrefix)}-${todayFullDateStr}.csv`;

  const exportToXlsx = useCallback(() => {
    const ws = utils.json_to_sheet(dataRows);
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Data export');
    writeFile(wb, `${filenamePrefix}.xlsx`);
  }, [dataRows, filenamePrefix]);

  return (
    <Box style={{ alignSelf: 'self-end' }}>
      <Menu>
        <MenuButton
          as={Button}
          variant="ghost"
          borderColor={colors.info}
          width="fit-content"
        >
          <Flex alignItems="center">
            <Icon icon="arrow-down-to-bracket" color={colors.info} />
            <Text color={colors.info} fontWeight={400} fontSize="14px" ml="8px">
              Download
            </Text>
          </Flex>
        </MenuButton>
        <MenuList zIndex={100}>
          <MenuItem>
            {/* !TODO @eldarshamukhmedov react-csv is no longer maintained, needs to be replaced */}
            <CSVLink data={dataRows} headers={headers} filename={filename}>
              <Text>Download CSV</Text>
            </CSVLink>
          </MenuItem>
          <MenuItem onClick={exportToXlsx}>Download XLSX</MenuItem>
        </MenuList>
      </Menu>
    </Box>
  );
};
